import { editQuoteApi, GenericModalApiParameter } from "@iewcasia/Services/CommonService";
import { getCustomQuote } from "@iewcasia/Services/QuoteService";
import { CustomState } from "@iewcasia/Store/Reducers";
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { GetQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";

type EditQuoteParameter = {
    message: string;
    responseInsite?: string;
    responseSF?: string;
    onError?: (error: string) => void;
} & GenericModalApiParameter &
    HasOnSuccess<any>;

type HandlerType = ApiHandler<EditQuoteParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    const {
        context: { session },
        customModals: { orderNumber: entityId },
    } = props.getState() as CustomState;

    props.apiParameter = {
        entityId,
        entityName: "Quote",
        firstName: session.firstName,
        lastName: session.lastName,
        email: session.email,
        message: props.parameter.message,
        responseInsite: props.parameter.responseInsite,
        responseSF: props.parameter.responseSF,
    };
};

export const DispatchOrderData: HandlerType = async props => {
    const { entityId: orderNumber } = props.apiParameter;
    const orderDataState = (props.getState() as CustomState).customModals.orderData;
    if (orderNumber && !orderDataState[orderNumber]) {
        const getOrderApiParameter: GetQuoteApiParameter = {
            quoteId: orderNumber,
        };
        const orderData = await getCustomQuote(getOrderApiParameter);
        props.dispatch({
            type: "Custom/Modals/OrderData",
            orderNumber,
            orderData,
        } as any);
        props.apiParameter.OrderData = orderData;
    } else {
        props.apiParameter.OrderData = orderDataState[orderNumber!];
    }
};

export const SendDataToApi: HandlerType = async props => {
    try {
        const result = await editQuoteApi(props.apiParameter);
        if (result.successful) {
            props.apiResult = result.result;
        } else {
            props.parameter.onError?.(result.errorMessage);
            return false;
        }
    } catch (error) {
        props.parameter.onError?.(error);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, DispatchOrderData, SendDataToApi, ExecuteOnSuccessCallback];

const editQuote = createHandlerChainRunner(chain, "EditQuote");
export default editQuote;
